import APPCONFIG from '../../constants/Config';
import {
  GET_DEVICE_MODELS,
  GET_DEVICE_MODELS_SUCCESS,
  GET_DEVICE_MODELS_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/deviceModel';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.deviceModel;
const deviceModel = (state = initialSettings, action) => {
  switch (action.type) {
    // LIST
    case GET_DEVICE_MODELS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: null,
          error: null,
          loading: true,
        },
      };
    case GET_DEVICE_MODELS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_DEVICE_MODELS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default deviceModel;



// WEBPACK FOOTER //
// ./reducers/device/deviceModel.js